import { useContext } from 'react';
import { AMSUserContext, AMSUserContextType } from 'src/components/users';

export const useUserContext = (): AMSUserContextType | undefined => {
  const userContext = useContext(AMSUserContext);
  return userContext !== null ? userContext : undefined;
};
